module.exports = __webpack_public_path__ + "static/media/AP_Moderate_Z2.b0b62621.png";